import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AdviserProfile } from '@syfo/types/adviser.types';

/**
 * Check authentication status and fetch user profile
 * Returns user profile if authenticated, null otherwise
 */
export const checkAuthThunk = createAsyncThunk<AdviserProfile | null>(
  'auth/checkAuth',
  async () => {
    console.log('[Auth] Checking authentication status...');
    
    try {
      const response = await fetch('/api/me');
      
      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const adviserProfile: AdviserProfile = await response.json();
          
          console.log('[Auth] User is authenticated:', adviserProfile.name);
          return adviserProfile;
        } else {
          console.log('[Auth] User is not authenticated (no JSON response)');
          return null;
        }
      } else {
        console.log('[Auth] User is not authenticated (response not OK)');
        return null;
      }
    } catch {
      // Silently fail auth check in local development (endpoint doesn't exist locally)
      console.log('[Auth] Auth check failed (likely local development)');
      return null;
    }
  }
);
